import { seoOgTwitterDescription } from './SeoStore';

export const updateSeoOgTwitterDescription = (value) => seoOgTwitterDescription.update(oldValue => value);
